import {ApprovalState, useApproveCallbackFromTrade} from '../../hooks/useApproveCallback'
import {ArrowWrapper, BottomGrouping, SwapCallbackError, Wrapper} from '../../components/swap/styleds'
import {AutoRow, RowBetween} from '../../components/Row'
import {ButtonConfirmed, ButtonError, ButtonLight, ButtonPrimary} from '../../components/ButtonLegacy'
import Card, {DarkCard, GreyCard} from '../../components/CardLegacy'
import {ChainId, CurrencyAmount, JSBI, Token, Trade} from '@sushiswap/sdk'
import Column, {AutoColumn} from '../../components/Column'
import {LinkStyledButton, TYPE} from '../../theme'
import React, {useCallback, useContext, useEffect, useMemo, useState, Component} from 'react'
import {computeTradePriceBreakdown, warningSeverity} from '../../utils/prices'
import {useAllTokens, useCurrency} from '../../hooks/Tokens'

import {
    useDefaultsFromURLSearch,
    useDerivedSwapInfo,
    useSwapActionHandlers,
    useSwapState
} from '../../state/swap/hooks'
import {useExpertModeManager, useUserSingleHopOnly, useUserSlippageTolerance} from '../../state/user/hooks'
import {useNetworkModalToggle, useToggleSettingsMenu, useWalletModalToggle} from '../../state/application/hooks'
import useWrapCallback, {WrapType} from '../../hooks/useWrapCallback'

import AddressInputPanel from '../../components/AddressInputPanel'
import AdvancedSwapDetailsDropdown from '../../components/swap/AdvancedSwapDetailsDropdown'
import {ArrowDown} from 'react-feather'
import {ClickableText} from '../Pool/styleds'
import ConfirmSwapModal from '../../components/swap/ConfirmSwapModal'
import CurrencyInputPanel from '../../components/CurrencyInputPanel'
import {Field} from '../../state/swap/actions'
import {Helmet} from 'react-helmet'
import {INITIAL_ALLOWED_SLIPPAGE} from '../../constants'
import {Link} from 'react-router-dom'
import Loader from '../../components/Loader'
import Lottie from 'lottie-react'
import PolygonLogo from '../../assets/images/matic-logo.png'
import ProgressSteps from '../../components/ProgressSteps'
import ReactGA from 'react-ga'
import SwapHeader from '../../components/ExchangeHeader'
import {SwapPoolTabs} from '../../components/NavigationTabs'
import {Text} from 'rebass'
import {ThemeContext} from 'styled-components'
import TokenWarningModal from '../../components/TokenWarningModal'
import TradePrice from '../../components/swap/TradePrice'
import UnsupportedCurrencyFooter from 'components/swap/UnsupportedCurrencyFooter'
import confirmPriceImpactWithoutFee from '../../components/swap/confirmPriceImpactWithoutFee'
import {isTradeBetter} from 'utils/trades'
import {maxAmountSpend} from '../../utils/maxAmountSpend'
import swapArrowsAnimationData from '../../assets/animation/swap-arrows.json'
import {t, Trans} from '@lingui/macro'
import {useActiveWeb3React} from '../../hooks/useActiveWeb3React'
import useENSAddress from '../../hooks/useENSAddress'
import {useIsTransactionUnsupported} from 'hooks/Trades'
import {useLingui} from '@lingui/react'
import {useSwapCallback} from '../../hooks/useSwapCallback'
import MisoBanner from '../../assets/images/miso-banner.jpg'
import MisoLogo from '../../assets/images/miso-logo.png'
import {useUser} from '../../hooks/useUser'
import Chart from './chart'
import {useRateCharts} from './useRateCharts'
import {useCurrencyBalance} from "../../state/wallet/hooks";
import axios from "axios";

export default function Dashboard() {
    const {i18n} = useLingui()
    const toggleNetworkModal = useNetworkModalToggle()

    const loadedUrlParams = useDefaultsFromURLSearch()

    const userdata = useUser()

    // token warning stuff
    const [loadedInputCurrency, loadedOutputCurrency] = [
        useCurrency(loadedUrlParams?.inputCurrencyId),
        useCurrency(loadedUrlParams?.outputCurrencyId)
    ]
    const [dismissTokenWarning, setDismissTokenWarning] = useState<boolean>(false)
    const urlLoadedTokens: Token[] = useMemo(
        () => [loadedInputCurrency, loadedOutputCurrency]?.filter((c): c is Token => c instanceof Token) ?? [],
        [loadedInputCurrency, loadedOutputCurrency]
    )
    const handleConfirmTokenWarning = useCallback(() => {
        setDismissTokenWarning(true)
    }, [])

    // dismiss warning if all imported tokens are in active lists
    const defaultTokens = useAllTokens()
    const importTokensNotInDefault =
        urlLoadedTokens &&
        urlLoadedTokens.filter((token: Token) => {
            return !Boolean(token.address in defaultTokens)
        })

    const {account, chainId} = useActiveWeb3React()
    const theme = useContext(ThemeContext)

    /** ##### **/

    const currencyETH = useCurrency("ETH")
    const currencyBITIN = useCurrency("0x39c3699ab94179b061bc84db29b9f39df8121c9b")
    const currencyUSDT = useCurrency("0xdAC17F958D2ee523a2206206994597C13D831ec7")

    // console.log(currencyETH)
    // console.log(currencyBITIN)
    // console.log(currencyUSDT)

    const balanceETH = useCurrencyBalance(account ?? undefined, currencyETH ?? undefined)
    const balanceBITIN = useCurrencyBalance(account ?? undefined, currencyBITIN ?? undefined)
    const balanceUSDT = useCurrencyBalance(account ?? undefined, currencyUSDT ?? undefined)

    // console.log(balanceETH)
    // console.log(balanceBITIN)
    // console.log(balanceUSDT)

    const [usdbit, setusdbit] = useState([])
    const [usdeth, setusdeth] = useState([])
    const [usdbic, setusdbic] = useState([])
    const [usdspt, setusdspt] = useState([])
    const [usdvai, setusdvai] = useState([])
    const [usdwbtc, setusdwbtc] = useState([])
    const [usdmatic, setusdmatic] = useState([])
    const [usdsand, setusdsand] = useState([])
    const [usduni, setusduni] = useState([])
    const [usdgrt, setusdgrt] = useState([])
    const [usdmkr, setusdmkr] = useState([])
    const [usdftm, setusdftm] = useState([])
    const [usdbit_per, setusdbit_per] = useState([])
    const [usdeth_per, setusdeth_per] = useState([])
    const [usdbic_per, setusdbic_per] = useState([])
    const [usdspt_per, setusdspt_per] = useState([])
    const [usdvai_per, setusdvai_per] = useState([])
    const [usdwbtc_per, setusdwbtc_per] = useState([])
    const [usdmatic_per, setusdmatic_per] = useState([])
    const [usdsand_per, setusdsand_per] = useState([])
    const [usduni_per, setusduni_per] = useState([])
    const [usdgrt_per, setusdgrt_per] = useState([])
    const [usdmkr_per, setusdmkr_per] = useState([])
    const [usdftm_per, setusdftm_per] = useState([])

    useEffect(() => {
        axios.get("https://auth.t-bitin.io/api/getrate")
            .then(res => {

                setusdbit(res.data["usdbit"])
                setusdeth(res.data["usdeth"])
                setusdbic(res.data["usdbic"])
                setusdspt(res.data["usdspt"])
                setusdvai(res.data["usdvai"])
                setusdwbtc(res.data["usdwbtc"])
                setusdmatic(res.data["usdmatic"])
                setusdsand(res.data["usdsand"])
                setusduni(res.data["usduni"])
                setusdgrt(res.data["usdgrt"])
                setusdmkr(res.data["usdmkr"])
                setusdftm(res.data["usdftm"])
                setusdbit_per(res.data["usdbit_per"])
                setusdeth_per(res.data["usdeth_per"])
                setusdbic_per(res.data["usdbic_per"])
                setusdspt_per(res.data["usdspt_per"])
                setusdvai_per(res.data["usdvai_per"])
                setusdwbtc_per(res.data["usdwbtc_per"])
                setusdmatic_per(res.data["usdmatic_per"])
                setusdsand_per(res.data["usdsand_per"])
                setusduni_per(res.data["usduni_per"])
                setusdgrt_per(res.data["usdgrt_per"])
                setusdmkr_per(res.data["usdmkr_per"])
                setusdftm_per(res.data["usdftm_per"])
            })
    },[])

    // スパークラインを実データで描画する。
    // account の有無でマークアップのブロックが入れ替わり canvas が作り直されるため、
    // account を依存に入れて描き直す。
    useRateCharts([account])

    let u_balanceBIT = null;
    let u_balanceETH = null;
    let u_balanceUSD = null;
    let d_balanceBIT = null;
    let d_balanceETH = null;
    let d_balanceUSD = null;
    let total_balance = null;
    let d_total_balance = null;

    if(usdbit && balanceBITIN){
        u_balanceBIT = Number(balanceBITIN.toSignificant(6)) / Number(usdbit)
        d_balanceBIT = u_balanceBIT.toString().substr(0,10)
    }

    if(usdbit && balanceUSDT){
        u_balanceUSD = Number(balanceUSDT.toSignificant(6))
        d_balanceUSD = u_balanceUSD.toString().substr(0,10)
    }

    if(usdbit && balanceETH){
        u_balanceETH = Number(balanceETH.toSignificant(6)) / Number(usdeth)
        d_balanceETH = u_balanceETH.toString().substr(0,10)
    }

    if(u_balanceETH && u_balanceBIT && u_balanceUSD){
        total_balance = u_balanceETH + u_balanceUSD
        d_total_balance = total_balance.toString().substr(0,10)
    }
    /** ##### **/

    // toggle wallet when disconnected
    const toggleWalletModal = useWalletModalToggle()

    // for expert modes
    const toggleSettings = useToggleSettingsMenu()
    const [isExpertMode] = useExpertModeManager()

    // get custom setting values for user
    const [allowedSlippage] = useUserSlippageTolerance()

    // swap state
    const {independentField, typedValue, recipient} = useSwapState()
    const {v2Trade, currencyBalances, parsedAmount, currencies, inputError: swapInputError} = useDerivedSwapInfo()
    const {wrapType, execute: onWrap, inputError: wrapInputError} = useWrapCallback(
        currencies[Field.INPUT],
        currencies[Field.OUTPUT],
        typedValue
    )

    const showWrap: boolean = wrapType !== WrapType.NOT_APPLICABLE
    const {address: recipientAddress} = useENSAddress(recipient)

    const trade = showWrap ? undefined : v2Trade

    const parsedAmounts = showWrap
        ? {
            [Field.INPUT]: parsedAmount,
            [Field.OUTPUT]: parsedAmount
        }
        : {
            [Field.INPUT]: independentField === Field.INPUT ? parsedAmount : trade?.inputAmount,
            [Field.OUTPUT]: independentField === Field.OUTPUT ? parsedAmount : trade?.outputAmount
        }

    const {onSwitchTokens, onCurrencySelection, onUserInput, onChangeRecipient} = useSwapActionHandlers()
    const isValid = !swapInputError
    const dependentField: Field = independentField === Field.INPUT ? Field.OUTPUT : Field.INPUT

    const handleTypeInput = useCallback(
        (value: string) => {
            onUserInput(Field.INPUT, value)
        },
        [onUserInput]
    )
    const handleTypeOutput = useCallback(
        (value: string) => {
            onUserInput(Field.OUTPUT, value)
        },
        [onUserInput]
    )

    // modal and loading
    const [{showConfirm, tradeToConfirm, swapErrorMessage, attemptingTxn, txHash}, setSwapState] = useState<{
        showConfirm: boolean
        tradeToConfirm: Trade | undefined
        attemptingTxn: boolean
        swapErrorMessage: string | undefined
        txHash: string | undefined
    }>({
        showConfirm: false,
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    })

    const formattedAmounts = {
        [independentField]: typedValue,
        [dependentField]: showWrap
            ? parsedAmounts[independentField]?.toExact() ?? ''
            : parsedAmounts[dependentField]?.toSignificant(6) ?? ''
    }

    const route = trade?.route
    const userHasSpecifiedInputOutput = Boolean(
        currencies[Field.INPUT] &&
        currencies[Field.OUTPUT] &&
        parsedAmounts[independentField]?.greaterThan(JSBI.BigInt(0))
    )
    const noRoute = !route

    // check whether the user has approved the router on the input token
    const [approval, approveCallback] = useApproveCallbackFromTrade(trade, allowedSlippage)

    // check if user has gone through approval process, used to show two step buttons, reset on token change
    const [approvalSubmitted, setApprovalSubmitted] = useState<boolean>(false)

    // mark when a user has submitted an approval, reset onTokenSelection for input field
    useEffect(() => {
        if (approval === ApprovalState.PENDING) {
            setApprovalSubmitted(true)
        }
    }, [approval, approvalSubmitted])

    const maxAmountInput: CurrencyAmount | undefined = maxAmountSpend(currencyBalances[Field.INPUT])
    const atMaxAmountInput = Boolean(maxAmountInput && parsedAmounts[Field.INPUT]?.equalTo(maxAmountInput))

    // the callback to execute the swap
    const {callback: swapCallback, error: swapCallbackError} = useSwapCallback(trade, allowedSlippage, recipient)

    const {priceImpactWithoutFee} = computeTradePriceBreakdown(trade)

    const [singleHopOnly] = useUserSingleHopOnly()

    const handleSwap = useCallback(() => {
        if (priceImpactWithoutFee && !confirmPriceImpactWithoutFee(priceImpactWithoutFee)) {
            return
        }
        if (!swapCallback) {
            return
        }
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm,
            showConfirm,
            swapErrorMessage: undefined,
            txHash: undefined
        })

        // console.error(userdata["user"])

        swapCallback()
            .then(hash => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: undefined,
                    txHash: hash
                })
                ReactGA.event({
                    category: 'Swap',
                    action:
                        recipient === null
                            ? 'Swap w/o Send'
                            : (recipientAddress ?? recipient) === account
                            ? 'Swap w/o Send + recipient'
                            : 'Swap w/ Send',
                    label: [
                        trade?.inputAmount?.currency?.getSymbol(chainId),
                        trade?.outputAmount?.currency?.getSymbol(chainId)
                    ].join('/')
                })

                ReactGA.event({
                    category: 'Routing',
                    action: singleHopOnly ? 'Swap with multihop disabled' : 'Swap with multihop enabled'
                })
            })
            .catch(error => {
                setSwapState({
                    attemptingTxn: false,
                    tradeToConfirm,
                    showConfirm,
                    swapErrorMessage: error.message,
                    txHash: undefined
                })
            })
    }, [
        priceImpactWithoutFee,
        swapCallback,
        tradeToConfirm,
        showConfirm,
        recipient,
        recipientAddress,
        account,
        trade,
        chainId,
        singleHopOnly
    ])

    // errors
    const [showInverted, setShowInverted] = useState<boolean>(false)

    // warnings on slippage
    const priceImpactSeverity = warningSeverity(priceImpactWithoutFee)

    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    const showApproveFlow =
        !swapInputError &&
        (approval === ApprovalState.NOT_APPROVED ||
            approval === ApprovalState.PENDING ||
            (approvalSubmitted && approval === ApprovalState.APPROVED)) &&
        !(priceImpactSeverity > 3 && !isExpertMode)

    const handleConfirmDismiss = useCallback(() => {
        setSwapState({showConfirm: false, tradeToConfirm, attemptingTxn, swapErrorMessage, txHash})
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(Field.INPUT, '')
        }
    }, [attemptingTxn, onUserInput, swapErrorMessage, tradeToConfirm, txHash])

    const handleAcceptChanges = useCallback(() => {
        setSwapState({tradeToConfirm: trade, swapErrorMessage, txHash, attemptingTxn, showConfirm})
    }, [attemptingTxn, showConfirm, swapErrorMessage, trade, txHash])

    const handleInputSelect = useCallback(
        inputCurrency => {
            setApprovalSubmitted(false) // reset 2 step UI for approvals
            onCurrencySelection(Field.INPUT, inputCurrency)
        },
        [onCurrencySelection]
    )

    const handleMaxInput = useCallback(() => {
        maxAmountInput && onUserInput(Field.INPUT, maxAmountInput.toExact())
    }, [maxAmountInput, onUserInput])

    const handleOutputSelect = useCallback(outputCurrency => onCurrencySelection(Field.OUTPUT, outputCurrency), [
        onCurrencySelection
    ])

    const swapIsUnsupported = useIsTransactionUnsupported(currencies?.INPUT, currencies?.OUTPUT)

    const [animateSwapArrows, setAnimateSwapArrows] = useState<boolean>(false)

    if(account) {
        return (
            <>
                <Helmet>
                    <title>{i18n._(t`Swap`)} | Bit-In</title>
                    <meta
                        name="description"
                        content="BitIn allows for swapping of ERC20 compatible tokens across multiple networks"
                    />
                </Helmet>
                <SwapPoolTabs active={'dashboard'}/>
                <div className="c-assets">
                    <div className="c-assets__inner u-flex--pc">
                        <div className="c-assets__content">
                            <div className="c-assets__head">
                                <div className="c-assets__head_total">
                                    <p className="c-assets__head_total_title">Balance</p>
                                    <div className="c-assets__head_total_num">{d_total_balance ?? "0"}
                                        <span className="c-assets__head_total_num_unit"></span>
                                    </div>
                                </div>
                                <p className="c-assets__head_change">USD</p>
                            </div>
                            <div className="c-assets__body">
                                <ul className="c-assets__list">
                                    <li className="c-assets__list_item">
                                        <div className="c-assets__list_item_icon u-icon u-icon--eth"></div>
                                        <p className="c-assets__list_item_name">Ethereum
                                            <span className="u-color1">ETH</span>
                                        </p>
                                        <p className="c-assets__list_item_num">
                                            <span className="u-weight--semi">{d_balanceETH ?? "0"}</span>USD
                                        </p>
                                    </li>
                                    {/*<li className="c-assets__list_item">*/}
                                    {/*    <div className="c-assets__list_item_icon u-icon u-icon--axa"></div>*/}
                                    {/*    <p className="c-assets__list_item_name">Axa Coin*/}
                                    {/*        <span className="u-color1">AXA</span>*/}
                                    {/*    </p>*/}
                                    {/*    <p className="c-assets__list_item_num">*/}
                                    {/*        <span className="u-weight--semi">{d_balanceBIT ?? "0"}</span>USD*/}
                                    {/*    </p>*/}
                                    {/*</li>*/}
                                    <li className="c-assets__list_item">
                                        <div className="c-assets__list_item_icon u-icon u-icon--usdt"></div>
                                        <p className="c-assets__list_item_name">Tether
                                            <span className="u-color1">USDT</span>
                                        </p>
                                        <p className="c-assets__list_item_num">
                                            <span className="u-weight--semi">{d_balanceUSD ?? "0"}</span>USD
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="c-assets__img"></div>
                    </div>
                </div>
                <div className="c-graph1__area">
                    <div className="c-graph1__area_inner">
                        <div className="c-graph1__area_head">
                            <p className="c-graph1__area_title u-pc">Currency</p>
                        </div>
                        <ul className="c-graph1__list">
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--eth"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Ethereum</p>
                                        <p className="c-graph1__list_item_name2 u-color1">ETH</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdeth ? (1 / Number(usdeth)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdeth_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdeth_per) >= 0 ? "+ " + Math.round(Number(usdeth_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdeth_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test1" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--axa"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Axa Coin</p>
                                        <p className="c-graph1__list_item_name2 u-color1">Axa</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdbit ? (1 / Number(usdbit)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdbit_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdbit_per) >= 0 ? "+ " + Math.round(Number(usdbit_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdbit_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test2" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--bic"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">BIC</p>
                                        <p className="c-graph1__list_item_name2 u-color1">BIC</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdbic ? (Number(usdbic)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdbic_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdbic_per) >= 0 ? "+ " + Math.round(Number(usdbic_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdbic_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test11" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x2034649F339c38EFEF15280BA33aED28FA830ED4&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x2034649F339c38EFEF15280BA33aED28FA830ED4"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--usdt"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Tether</p>
                                        <p className="c-graph1__list_item_name2 u-color1">USDT</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD 1.00</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className="c-graph1__list_item_change3 c-graph1__list_item_change3--up"> +0.00%</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test3" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0xdAC17F958D2ee523a2206206994597C13D831ec7&outputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b&outputCurrency=0xdAC17F958D2ee523a2206206994597C13D831ec7"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--spt"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Sportia</p>
                                        <p className="c-graph1__list_item_name2 u-color1">SPT</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdspt ? (Number(usdspt)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdspt_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdspt_per) >= 0 ? "+ " + Math.round(Number(usdspt_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdspt_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test12" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x77DE781e4ae0E5594e78321b9d42596f7a5aa6C4&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x77DE781e4ae0E5594e78321b9d42596f7a5aa6C4"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--vai"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Virtual AI</p>
                                        <p className="c-graph1__list_item_name2 u-color1">VAI</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdvai ? (Number(usdvai)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdvai_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdvai_per) >= 0 ? "+ " + Math.round(Number(usdvai_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdvai_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test13" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x89ca167410E1118E3c3Ebd07007B38eA5fcF2148&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x89ca167410E1118E3c3Ebd07007B38eA5fcF2148"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--wbtc"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Wrapped Bitcoin</p>
                                        <p className="c-graph1__list_item_name2 u-color1">WBTC</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdwbtc ? (Number(usdwbtc)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdwbtc_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdwbtc_per) >= 0 ? "+ " + Math.round(Number(usdwbtc_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdwbtc_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test4" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--sand"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">SAND</p>
                                        <p className="c-graph1__list_item_name2 u-color1">SAND</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdsand ? (Number(usdsand)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdsand_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdsand_per) >= 0 ? "+ " + Math.round(Number(usdsand_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdsand_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test5" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x3845badAde8e6dFF049820680d1F14bD3903a5d0&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x3845badAde8e6dFF049820680d1F14bD3903a5d0"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--matic"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Polygon</p>
                                        <p className="c-graph1__list_item_name2 u-color1">MATIC</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdmatic ? (Number(usdmatic)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdmatic_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdmatic_per) >= 0 ? "+ " + Math.round(Number(usdmatic_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdmatic_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test6" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--uni"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Uniswap</p>
                                        <p className="c-graph1__list_item_name2 u-color1">UNI</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usduni ? (Number(usduni)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usduni_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usduni_per) >= 0 ? "+ " + Math.round(Number(usduni_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usduni_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test7" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0xBf5140A22578168FD562DCcF235E5D43A02ce9B1&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0xBf5140A22578168FD562DCcF235E5D43A02ce9B1"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--mkr"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Maker</p>
                                        <p className="c-graph1__list_item_name2 u-color1">MKR</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdmkr ? (Number(usdmkr)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdmkr_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdmkr_per) >= 0 ? "+ " + Math.round(Number(usdmkr_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdmkr_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test8" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--grt"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">The Graph</p>
                                        <p className="c-graph1__list_item_name2 u-color1">GRT</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdgrt ? (Number(usdgrt)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdgrt_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdgrt_per) >= 0 ? "+ " + Math.round(Number(usdgrt_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdgrt_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test9" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0xc944E90C64B2c07662A292be6244BDf05Cda44a7&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0xc944E90C64B2c07662A292be6244BDf05Cda44a7"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--ftm"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Fantom Token</p>
                                        <p className="c-graph1__list_item_name2 u-color1">FTM</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdftm ? (Number(usdftm)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdftm_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdftm_per) >= 0 ? "+ " + Math.round(Number(usdftm_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdftm_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test10" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x4E15361FD6b4BB609Fa63C81A2be19d873717870&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x4E15361FD6b4BB609Fa63C81A2be19d873717870"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </>
        )
    }else{
        return (
            <>
                <Helmet>
                    <title>{i18n._(t`Swap`)} | Bit-In</title>
                    <meta
                        name="description"
                        content="BitIn allows for swapping of ERC20 compatible tokens across multiple networks"
                    />
                </Helmet>
                <SwapPoolTabs active={'dashboard'}/>
                <div className="c-assets">
                    <div className="c-assets__inner u-flex--pc align-center">
                        <div className="c-assets__content">
                            <div className="c-assets__content_inner">
                                <div className="c-assets__content_logo">
                                    <img src="/images/logo_main.png" alt="" />
                                </div>
                                <a className="c-assets__content_btn" href="javascript:void(0)" onClick={toggleWalletModal}>{i18n._(t`Connect to a wallet`)}</a>
                            </div>
                        </div>
                        <div className="c-assets__img"></div>
                    </div>
                </div>
                <div className="c-graph1__area">
                    <div className="c-graph1__area_inner">
                        <div className="c-graph1__area_head">
                            <p className="c-graph1__area_title u-pc">Currency</p>
                        </div>
                        <ul className="c-graph1__list">
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--eth"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Ethereum</p>
                                        <p className="c-graph1__list_item_name2 u-color1">ETH</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdeth ? (1 / Number(usdeth)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdeth_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdeth_per) >= 0 ? "+ " + Math.round(Number(usdeth_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdeth_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test1" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--axa"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Axa Coin</p>
                                        <p className="c-graph1__list_item_name2 u-color1">AXA</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdbit ? (1 / Number(usdbit)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdbit_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdbit_per) >= 0 ? "+ " + Math.round(Number(usdbit_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdbit_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test2" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--bic"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">BIC</p>
                                        <p className="c-graph1__list_item_name2 u-color1">BIC</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdbic ? (Number(usdbic)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdbic_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdbic_per) >= 0 ? "+ " + Math.round(Number(usdbic_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdbic_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test11" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x2034649F339c38EFEF15280BA33aED28FA830ED4&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x2034649F339c38EFEF15280BA33aED28FA830ED4"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--usdt"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Tether</p>
                                        <p className="c-graph1__list_item_name2 u-color1">USDT</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD 1.00</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className="c-graph1__list_item_change3 c-graph1__list_item_change3--up"> +0.00%</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test3" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0xdAC17F958D2ee523a2206206994597C13D831ec7&outputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=0x39c3699ab94179b061bc84db29b9f39df8121c9b&outputCurrency=0xdAC17F958D2ee523a2206206994597C13D831ec7"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--spt"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Sportia</p>
                                        <p className="c-graph1__list_item_name2 u-color1">SPT</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdspt ? (Number(usdspt)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdspt_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdspt_per) >= 0 ? "+ " + Math.round(Number(usdspt_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdspt_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test12" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x77DE781e4ae0E5594e78321b9d42596f7a5aa6C4&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x77DE781e4ae0E5594e78321b9d42596f7a5aa6C4"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--vai"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Virtual AI</p>
                                        <p className="c-graph1__list_item_name2 u-color1">VAI</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdvai ? (Number(usdvai)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdvai_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdvai_per) >= 0 ? "+ " + Math.round(Number(usdvai_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdvai_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test13" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x89ca167410E1118E3c3Ebd07007B38eA5fcF2148&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x89ca167410E1118E3c3Ebd07007B38eA5fcF2148"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--wbtc"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Wrapped Bitcoin</p>
                                        <p className="c-graph1__list_item_name2 u-color1">WBTC</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdwbtc ? (Number(usdwbtc)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdwbtc_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdwbtc_per) >= 0 ? "+ " + Math.round(Number(usdwbtc_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdwbtc_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test4" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599b&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--sand"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">SAND</p>
                                        <p className="c-graph1__list_item_name2 u-color1">SAND</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdsand ? (Number(usdsand)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdsand_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdsand_per) >= 0 ? "+ " + Math.round(Number(usdsand_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdsand_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test5" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x3845badAde8e6dFF049820680d1F14bD3903a5d0&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x3845badAde8e6dFF049820680d1F14bD3903a5d0"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--matic"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Polygon</p>
                                        <p className="c-graph1__list_item_name2 u-color1">MATIC</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdmatic ? (Number(usdmatic)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdmatic_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdmatic_per) >= 0 ? "+ " + Math.round(Number(usdmatic_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdmatic_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test6" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--uni"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Uniswap</p>
                                        <p className="c-graph1__list_item_name2 u-color1">UNI</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usduni ? (Number(usduni)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usduni_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usduni_per) >= 0 ? "+ " + Math.round(Number(usduni_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usduni_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test7" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0xBf5140A22578168FD562DCcF235E5D43A02ce9B1&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0xBf5140A22578168FD562DCcF235E5D43A02ce9B1"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--mkr"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Maker</p>
                                        <p className="c-graph1__list_item_name2 u-color1">MKR</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdmkr ? (Number(usdmkr)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdmkr_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdmkr_per) >= 0 ? "+ " + Math.round(Number(usdmkr_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdmkr_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test8" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--grt"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">The Graph</p>
                                        <p className="c-graph1__list_item_name2 u-color1">GRT</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdgrt ? (Number(usdgrt)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdgrt_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdgrt_per) >= 0 ? "+ " + Math.round(Number(usdgrt_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdgrt_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test9" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0xc944E90C64B2c07662A292be6244BDf05Cda44a7&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0xc944E90C64B2c07662A292be6244BDf05Cda44a7"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                            <li className="c-graph1__list_item">
                                <div className="c-graph1__list_item1">
                                    <div className="c-graph1__list_item_icon u-icon u-icon--ftm"></div>
                                    <div className="c-graph1__list_item_name">
                                        <p className="c-graph1__list_item_name1">Fantom Token</p>
                                        <p className="c-graph1__list_item_name2 u-color1">FTM</p>
                                    </div>
                                    <div className="c-graph1__list_item_change">
                                        <div>
                                            <p className="c-graph1__list_item_change1">USD {usdftm ? (Number(usdftm)).toString().substr(0, 6) : ""}</p>
                                            {/*<p className="c-graph1__list_item_change2 u-color1">AED 84,085.60</p>*/}
                                        </div>
                                        <p className={Number(usdftm_per) > 0 ? "c-graph1__list_item_change3 c-graph1__list_item_change3--up" : "c-graph1__list_item_change3"}>
                                            {Number(usdftm_per) >= 0 ? "+ " + Math.round(Number(usdftm_per) * 100) / 100 : "-" + Math.abs(Math.round(Number(usdftm_per) * 100) / 100).toString()}
                                            %</p>
                                    </div>
                                </div>
                                <div className="c-graph1__list_item2">
                                    <div className="c-graph1">
                                        <canvas id="test10" className="js-chart c-graph1__canvas"></canvas>
                                    </div>
                                    <div className="c-graph1__list_item_btn_wrap">
                                        <a href="/swap?inputCurrency=0x4E15361FD6b4BB609Fa63C81A2be19d873717870&outputCurrency=ETH"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn1">Sell</a>
                                        <a href="/swap?inputCurrency=ETH&outputCurrency=0x4E15361FD6b4BB609Fa63C81A2be19d873717870"
                                           className="c-graph1__list_item_btn c-graph1__list_item_btn2">Buy</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </>
        )
    }
}
